<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Auditorías</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col align="right">
            <!-- <TextButton @click="openRegistroNuevaAuditoria">Registrar auditoría</TextButton> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="auditoriasTable" class="transparent" :loading="loading">
                  <template v-slot:[`item.fecha`]="{ item }">
                    {{ formatFecha(item.fecha) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import TextButton from '../../base/TextButton.vue'
import IconButton from '../../base/IconButton.vue'
import { DIALOG_TYPES } from '../../../plugins/dialog-types.js'

export default {
  components: {
    TextButton,
    IconButton,
  },
  data() {
    return {
      headers: [
        { text: 'Información', value: 'informacion', width: '20%' },
        { text: 'Fecha', value: 'fecha', width: '15%' },
        { text: 'Personal Emisor', value: 'fk_idPersonalEmisor', width: '15%' },
        { text: 'Personal Receptor', value: 'fk_idPersonalReceptor', width: '15%' },
        { text: 'Arma', value: 'fk_idArma', width: '15%' },
      ],
      loading: false,
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('armeria', {
      auditorias: 'getAuditorias',
    }),
    auditoriasTable() {
      return Array.isArray(this.auditorias) ? this.auditorias : []
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    openRegistroNuevaAuditoria() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_NUEVA_AUDITORIA)
    },
    formatFecha(fecha) {
      return fecha ? moment(fecha).format('DD/MM/YYYY') : ''
    },
  },
  created() {
    this.$store.dispatch('armeria/fetchAuditorias')
  },
}
</script>

<style scoped>
/* Estilos modernos para Auditorias */
.card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
.v-card-title {
  color: #e0e0e0 !important;
}

.text-h5 {
  color: #e0e0e0 !important;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(108, 92, 231, 0.15) 0%, rgba(108, 92, 231, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
  transform: scale(1.005);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
  padding: 16px !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

::v-deep .v-btn:hover::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  color: #ffffff !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

::v-deep .v-btn:hover .v-icon {
  color: #ffffff !important;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #e0e0e0 !important;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
